export const volumes = [
  {
    numeral: "I",
    title: "The Aesthetic Laser Fundamentals & Physics Guide",
    tagline: "Build a structured foundation for understanding aesthetic laser technologies.",
    intro: [
      "Understanding the fundamental principles behind laser technologies provides important context for studying their applications in aesthetic practice.",
      "In this volume, I bring together educational references covering the physical principles, terminology, and foundational concepts relevant to aesthetic laser education.",
    ],
    items: [
      "Fundamental laser physics concepts",
      "Wavelength and light interaction principles",
      "Selective photothermolysis and its educational foundations",
      "Pulse duration and energy terminology",
      "Fluence and spot size concepts",
      "Tissue interaction and optical absorption",
      "Differences between major laser technology categories",
      "Educational diagrams and terminology references",
    ],
    note: "This volume provides foundational educational material. It does not establish device-specific operating parameters or authorize independent operation of laser equipment.",
  },
  {
    numeral: "II",
    title: "The Skin Assessment & Laser Interaction Atlas",
    tagline: "Organize your study of skin characteristics and laser-tissue interactions.",
    intro: [
      "Skin characteristics influence how professionals evaluate aesthetic concerns and study the potential applications and limitations of different technologies.",
      "This volume organizes educational references on skin anatomy, pigmentation, tissue characteristics, and laser interaction concepts.",
    ],
    items: [
      "Skin anatomy and structural references",
      "Epidermal and dermal characteristics",
      "Melanin and pigmentation fundamentals",
      "Hemoglobin and relevant chromophore concepts",
      "Fitzpatrick skin phototype classification",
      "Skin characteristics and individual variation",
      "Educational references on tissue responses",
      "Skin assessment worksheets",
    ],
    note: "The materials support educational review and do not replace individualized clinical assessment or device-specific guidance.",
  },
  {
    numeral: "III",
    title: "The Aesthetic Laser Technology & Applications Guide",
    tagline: "Understand the educational differences between major laser technology categories.",
    intro: [
      "Aesthetic laser education involves understanding how different technologies work and why their applications and limitations differ.",
      "This volume organizes educational references around major categories of laser technologies and their commonly discussed aesthetic applications.",
    ],
    items: [
      "Alexandrite laser fundamentals",
      "Diode laser technology concepts",
      "Nd:YAG laser characteristics",
      "Fractional laser technology fundamentals",
      "Ablative and non-ablative laser concepts",
      "Pigment-targeting technology principles",
      "Vascular laser technology concepts",
      "Comparative technology reference charts",
      "Educational application and limitation summaries",
    ],
    note: "The specific indications, contraindications, and appropriate settings depend on the device, its instructions for use, the individual patient, and applicable professional guidance.",
  },
  {
    numeral: "IV",
    title: "The Aesthetic Laser Treatment Planning Workbook",
    tagline: "Organize the educational considerations behind laser-based treatment planning.",
    intro: [
      "Professional treatment planning requires consideration of the intended application, relevant skin characteristics, individual circumstances, device-specific instructions, and potential risks.",
      "This volume provides structured educational worksheets to help organize these considerations.",
    ],
    items: [
      "Educational consultation preparation worksheets",
      "Skin characteristic documentation frameworks",
      "Treatment objective organization templates",
      "Patient history review checklists",
      "Contraindication review prompts",
      "Technology selection discussion frameworks",
      "Treatment planning documentation worksheets",
      "Hypothetical case analysis exercises",
    ],
    note: "These resources are intended for qualified professionals to adapt to their scope of practice. They do not prescribe individualized treatment plans or provide universal laser settings.",
  },
  {
    numeral: "V",
    title: "The Aesthetic Laser Safety & Complications Reference",
    tagline: "Organize your study of laser safety and potential adverse events.",
    intro: [
      "Laser-based aesthetic procedures require appropriate training, device-specific safety practices, and an understanding of potential adverse events.",
      "I designed this educational volume to bring relevant safety concepts and documentation references together in one organized resource.",
    ],
    items: [
      "General laser safety principles",
      "Eye protection and wavelength-related considerations",
      "Treatment environment safety checklists",
      "Potential skin reactions and adverse events",
      "Educational references on burns and pigmentary changes",
      "Infection prevention concepts",
      "Post-treatment observation documentation",
      "Warning signs that may require prompt medical evaluation",
      "Incident documentation frameworks",
      "Referral and escalation considerations",
    ],
    note: "This volume does not replace formal laser safety training, device-specific instructions, emergency protocols, or current clinical guidelines.",
  },
  {
    numeral: "VI",
    title: "The Aesthetic Laser Clinical Documentation & Follow-Up Guide",
    tagline: "Bring greater structure to your professional records.",
    intro: [
      "Consultation notes, treatment records, consent documentation, photographs, and follow-up information can involve multiple documents and information sources.",
      "This volume focuses on organizing documentation resources that can be adapted to an appropriate professional setting.",
    ],
    items: [
      "Patient consultation documentation templates",
      "Medical history review worksheets",
      "Skin assessment record frameworks",
      "Informed consent documentation checklists",
      "Treatment record organization templates",
      "Photographic documentation checklists",
      "Follow-up observation forms",
      "Adverse-event documentation worksheets",
      "Patient communication record templates",
      "Professional record review checklists",
    ],
    note: "All templates should be reviewed and adapted to your professional scope, privacy requirements, applicable regulations, and local documentation standards.",
  },
];
